import { useCallback, useMemo } from 'react';

import { useGraphql } from '../graphql';
import { useLoad } from '../load';

// What waits for the clinician on the Dashboard, in one request: the
// invitations not answered yet and the submitted tests they have not
// reviewed. data is undefined until the answer arrives or when it failed;
// error and retry are useLoad's.
export function useDashboard() {
  const graphql = useGraphql();

  const read = useCallback(function() {
    return graphql({
      document: `query Dashboard {
        sentInvitations { id email name status sentAt }
        toReview { attemptId patientId patientName questionnaire submittedAt }
      }`
    });
  }, [ graphql ]);

  const { data, error, retry } = useLoad(read);

  return useMemo(function() {
    return { data, error, retry };
  }, [ data, error, retry ]);
}
